import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MessageService } from './shared/services/message.service';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';

@Component({
	selector: 'ziggy-root',
	imports: [
		RouterOutlet,

		ConfirmDialogComponent
	],
	templateUrl: './app.html',
})
export class App {
	notify = inject(MessageService);
}
